export enum alertTypes {
  accountBalanceBelowThreshold = 'Account Balance Below Threshold',
}
